import { getLocale } from 'i18n';
import { tr } from 'i18n';
import { reportBase, reportStageTotal } from 'components/Erp/IntegrationStages';

const emptyCoal = () => ({ net_kg: '0.000', tonnes: '0.000000', departures: 0, weighed_departures: 0, missing_weight_departures: 0 });
export const mergeCoalBases = (baseStats = [], coalExport) => {
  const coalBases = Array.isArray(coalExport?.bases) ? coalExport.bases : [];
  const completeReport = Boolean(coalExport?.periods?.selected) && Array.isArray(coalExport?.bases);
  const used = new Set();
  const nameCount = name => baseStats.filter(base => base.name === name).length;
  const rows = baseStats.map((base, index) => {
    let matched = base.key ? coalBases.find(coal => coal.key === base.key) : undefined;
    const sameName = coalBases.filter(coal => coal.name === base.name);
    if (!matched && (!base.key || sameName.some(coal => !coal.key)) && sameName.length === 1 && nameCount(base.name) === 1) matched = sameName[0];
    if (matched) used.add(matched);
    const uncertain = !base.key && sameName.length > 0 && !matched;
    return { ...reportBase(base), key: base.key || matched?.key || `legacy:${index}`, coal: matched || (completeReport && !uncertain ? emptyCoal() : null), kind: matched?.kind || base.key?.split(':')[0] || 'unknown' };
  });
  coalBases.forEach((coal, index) => {
    if (!used.has(coal)) rows.push({ ...reportBase({ name: coal.name }), key: coal.key || `coal:${index}`, coal, kind: coal.kind || 'unknown' });
  });
  return rows.sort((a, b) => reportStageTotal(b) - reportStageTotal(a) || Number(b.coal?.tonnes || 0) - Number(a.coal?.tonnes || 0) || a.name.localeCompare(b.name, getLocale()));
};

export const sumCoalBases = (rows, knownReport = false) => {
  if (!rows.length) return knownReport ? emptyCoal() : null;
  if (rows.some(row => !row.coal)) return null;
  const sum = field => rows.reduce((total, row) => total + Number(row.coal[field] || 0), 0);
  return { tonnes: sum('tonnes').toFixed(6), net_kg: sum('net_kg').toFixed(3), departures: sum('departures'), weighed_departures: sum('weighed_departures'), missing_weight_departures: sum('missing_weight_departures') };
};
